// Desc: 状态管理
export default {
    isLogin: false,
    mobile: "",
    isBind: false,
    lastGameRid: "",
    lastServerId: "",
    userId: "",
    token: "",
}